// SnapMark: four rounded pills in an X (red, blue, green, yellow) — PLENA SNAP studio mark.
export const SnapMark = ({ size = 28, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" className={className} aria-label="SnapMark" data-testid="snap-mark">
    <rect x="8" y="8" width="20" height="9" rx="4.5" fill="#E2574C" transform="rotate(45 18 12.5)" />
    <rect x="36" y="8" width="20" height="9" rx="4.5" fill="#4A7BF7" transform="rotate(-45 46 12.5)" />
    <rect x="8" y="47" width="20" height="9" rx="4.5" fill="#5BAE6B" transform="rotate(-45 18 51.5)" />
    <rect x="36" y="47" width="20" height="9" rx="4.5" fill="#F0B83C" transform="rotate(45 46 51.5)" />
  </svg>
);
